// Datos del negocio - Fuente de verdad
export const siteData = {
  business: {
    name: "Filosofía Peluquería y Barbería Social",
    shortName: "Filosofía",
    tagline: "Tu estilo, nuestra filosofía",
    description: "Un espacio donde la belleza se encuentra con la inclusión. Más que una peluquería, somos un lugar donde cada persona es bienvenida tal como es.",
    logo: "https://customer-assets.emergentagent.com/job_0624f94e-ffc0-4780-803d-c6d6c1e543f9/artifacts/qqoaxb1l_filosofia_logo.jpg"
  },
  hero: {
    title: "Donde tu estilo cobra vida",
    subtitle: "Asesoramiento personalizado en un ambiente inclusivo y acogedor. Transformamos tu look respetando tu esencia.",
    cta: {
      text: "Reservar turno por WhatsApp",
      url: "https://wa.me/5493416286005"
    }
  },
  values: [
    {
      id: 1,
      title: "Ambiente Inclusivo",
      description: "Un espacio donde todas las personas son bienvenidas, sin importar quiénes sean.",
      icon: "Heart"
    },
    {
      id: 2,
      title: "LGBTQ+ Friendly",
      description: "Nos enorgullece ser un lugar seguro y respetuoso para toda la comunidad.",
      icon: "Rainbow"
    },
    {
      id: 3,
      title: "PET Friendly",
      description: "Tu mascota también es parte de la familia. Traela con vos mientras te atendemos.",
      icon: "PawPrint"
    },
    {
      id: 4,
      title: "Asesoramiento Personalizado",
      description: "Cada cliente es único. Te ayudamos a encontrar el look que mejor te representa.",
      icon: "Sparkles"
    }
  ],
  services: [
    {
      id: 1,
      name: "Color Completo",
      description: "Transformación total de tu color de cabello con productos de primera calidad.",
      icon: "Palette"
    },
    {
      id: 2,
      name: "Californianas",
      description: "Mechas naturales que iluminan tu rostro con un efecto degradado sutil.",
      icon: "Sun"
    },
    {
      id: 3,
      name: "Color Fantasía",
      description: "Colores vibrantes y únicos para quienes buscan expresar su personalidad.",
      icon: "Wand2"
    },
    {
      id: 4,
      name: "Barbería",
      description: "Cortes clásicos y modernos, perfilado de barba y tratamientos especializados.",
      icon: "Scissors"
    }
  ],
  reputation: {
    rating: 4.6,
    totalReviews: 130,
    reviews: [
      {
        id: 1,
        author: "María L.",
        text: "Excelente atención y muy profesionales. El ambiente es súper cálido y te hacen sentir como en casa.",
        rating: 5
      },
      {
        id: 2,
        author: "Lucas G.",
        text: "La mejor barbería de Rosario. Siempre salgo contento con el resultado y el trato es impecable.",
        rating: 5
      },
      {
        id: 3,
        author: "Valentina R.",
        text: "Me encantó mi color fantasía. Escucharon lo que quería y el resultado superó mis expectativas.",
        rating: 5
      }
    ]
  },
  locations: [
    {
      id: 1,
      city: "Rosario, Argentina",
      address: "Mendoza 2516, Rosario, Santa Fe",
      phone: "+54 9 341 628-6005",
      whatsapp: "https://wa.me/5493416286005",
      mapsUrl: "https://www.google.com/maps/place/382R%2BRC+Rosario,+Santa+Fe",
      plusCode: "382R+RC Rosario, Santa Fe"
    },
    {
      id: 2,
      city: "Barcelona, España",
      address: "C/ Girona 35, Barcelona, España",
      phone: "+34 653 934 032",
      whatsapp: "https://wa.me/34653934032",
      mapsUrl: "https://www.google.com/maps/search/?api=1&query=C%2F+Girona+35%2C+Barcelona%2C+Espa%C3%B1a",
      plusCode: null
    }
  ],
  social: {
    instagram: "https://www.instagram.com/filosofiapeluqueria/",
    instagramHandle: "@filosofiapeluqueria"
  },
  footer: {
    year: new Date().getFullYear(),
    developer: {
      name: "Appolo",
      url: "https://www.somosappolo.com"
    }
  }
};
